webpackJsonp([275805287939862],{

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1.0224464e.png";

/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2.6165387b.png";

/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3.4d2124a5.png";

/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/4.0ae88c2f.png";

/***/ }),

/***/ 1189:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(886);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(887);
	
	var _4 = _interopRequireDefault(_3);
	
	var _5 = __webpack_require__(888);
	
	var _6 = _interopRequireDefault(_5);
	
	var _7 = __webpack_require__(889);
	
	var _8 = _interopRequireDefault(_7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function Index(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "c-content-box" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Tesi di laurea magistrale"
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { textAlign: 'justify', lineHeight: '2em' } },
	      _react2.default.createElement("img", { src: _2.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Generalit\xE0"
	      ),
	      "Uno degli argomenti di maggiore interesse della moderna Ingegneria delle Strutture \xE8 quello della valutazione del livello di sicurezza delle costruzioni esistenti: le cosiddette analisi di vulnerabilit\xE0 o Assessment. Attenzione particolare \xE8 posta nella valutazione della vulnerabilit\xE0 sismica delle strutture. Infatti in Italia, ma non solo, le strutture esistenti sono particolarmente datate e progettate secondo codici normativi che non prevedono una adeguata filosofia sismica. Restringendo il campo alle strutture da ponte si pu\xF2 dire che esse hanno notevole importanza poich\xE9 in molti casi risultano essere nodi cruciali della rete di trasporti. Per quanto detto il loro livello prestazionale deve essere garantito anche nei momenti immediatamente successivi ad un sisma.  ",
	      _react2.default.createElement("br", null),
	      "E\u2019 quindi fondamentale, per gli enti gestori, conoscere lo stato di consistenza del parco infrastrutturale per predisporre i piani di ispezione, manutenzione e intervento. Coinvolgendo un gran numero di infrastrutture sul territorio, questo processo pu\xF2 essere in conflitto con la limitata disponibilit\xE0 economica. Pertanto la scala estesa delle valutazioni da un lato e l'insufficienza di risorse dall'altro rendono necessaria la razionalizzazione dei metodi di Assessment affinch\xE9 siano pi\xF9 snelli e versatili rispetto al caso del singolo manufatto. Lo scopo principale delle analisi di questo tipo \xE8 quindi quello di stabilire delle liste di priorit\xE0. Grazie alle suddette liste \xE8 possibile capire quali strutture necessitano interventi immediati, procedere ad analisi pi\xF9 approfondite e progettare gli interventi stessi. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("img", { src: _4.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Vulnerabilit\xE0 sismica a scala regionale"
	      ),
	      "Allo stato attuale le analisi di vulnerabilit\xE0 di questo tipo sono impostate su check-list che guidano le ispezioni visive alle strutture in esame. Si procede al calcolo di indici sintetici che quantificano il danno/degrado che la struttura presenta, la sua danneggiabilit\xE0 (fissato un evento sismico di riferimento) e la sua perdita di funzionalit\xE0 (che quantifica le perdite indirette legate al fatto che il ponte risulta essere inagibile).  ",
	      _react2.default.createElement("br", null),
	      "Un problema che accomuna tutte le procedure di analisi di questo tipo \xE8 la loro soggettivit\xE0. Infatti gli indici sopra menzionati dipendono da parametri il cui valore numerico \xE8 assegnato da chi effettua l'ispezione. Inoltre ogni parametro possiede un peso che \xE8 definito dall'autore della procedura stessa. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("img", { src: _6.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Obiettivo del lavoro"
	      ),
	      "L'obiettivo del lavoro di tesi \xE8 quindi quello di progettare un metodo basato su modelli meccanici, e quindi oggettivo, per effettuare valutazioni di vulnerabilit\xE0. Il metodo proposto \xE8 di semplice utilizzo, \xE8 basato su un livello di conoscenza poco dispendioso in termini di costo dell'indagine ma allo stesso tempo \xE8 impostato su criteri e modelli congruenti coi moderni approcci alle problematiche sismiche. ",
	      _react2.default.createElement("br", null),
	      " ",
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("img", { src: _8.default, style: { width: '100%', height: '100%' } })
	    )
	  );
	};
	
	exports.default = Index;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-master-it-jsx-ccc8848eafb0980df4e9.js